module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("StuG III Brigade 191, 1940–1945")])]), _vm._v(" "), _c('p', {
    staticClass: "stitle"
  }, [_vm._v("The Buffalo Brigade in Action in the Balkans,")]), _vm._v(" "), _c('p', {
    staticClass: "stitle0"
  }, [_vm._v("Greece and from Moscow to")]), _vm._v(" "), _c('p', {
    staticClass: "stitle0"
  }, [_vm._v("Kursk and Sevastopol")]), _vm._v(" "), _c('p', {
    staticClass: "author1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bruno Bork")])]), _vm._v(" "), _c('p', {
    staticClass: "author2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Foreword by Anthony Tucker-Jones")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c0d47ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Title.vue
// module id = 60
// module chunks = 0